"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultThemeId = exports.themes = void 0;
var light_1 = require("./light");
var dark_1 = require("./dark");
var coffee_1 = require("./coffee");
var deepsea_1 = require("./deepsea");
// This ensures all themes are defined and valid
exports.themes = {
    dark: dark_1.dark,
    light: light_1.light,
    coffee: coffee_1.coffee,
    deepsea: deepsea_1.deepsea,
};
exports.defaultThemeId = "dark";
//# sourceMappingURL=index.js.map